export enum UserRole {
  ADMIN = 'ADMIN',
  DEVELOPER = 'DEVELOPER',
  STAFF = 'STAFF',
  GUEST = 'GUEST',
}
